import styled from 'styled-components';

export const Wrapper = styled.div`
	/* background-color: var(--header-bg_color); */

	.header-nav {
		display: flex;
		align-items: center;
		justify-content: space-between;
		position: relative;
		gap: 4px;
		.nav-link {
			flex: 1;
			height: 95px;
			background-color: var(--tab-link-bgColor);
			font-size: 13px;
			line-height: 20px;
			font-weight: 500;
			color: var(--tab-link-color);
			display: flex;
			align-items: center;
			justify-content: end;
			flex-direction: column;
			padding-bottom: 12px;
			cursor: pointer;
			&:hover,
			&.active {
				background-color: var(--tab-link-bgColor-hover);
				color: var(--tab-link-color-hover);
				border-bottom: 1px solid #dfdfdf;
				svg {
					.path-stroke {
						stroke: #002970;
					}
					.path-color {
						fill: #002970;
					}
					.path-stroke-white {
						stroke: #fff;
					}
					#Aadhaar_pay-blue-without_name path{
						fill: #002970;
					}
					#Path_197,
					#Line_2,
					#Line_5,
					
					#Ellipse_42{
						stroke: #002970;
					}
				
				
				
			}
			.pic{
				width: 100%;
				//height: 76px;
				display: flex;
				align-items: center;
				justify-content: center;
			}
			&.active .pic,
			&:hover .pic{
				svg {
					#Subtraction_4,
					#Path_550{
						stroke:#002970
					}
				}
			}
		}
	}
	}
	.slick-slider {
		width: 100%;
	}
	
	.slick-track{
		display: flex;
		gap: 5px;
		margin-left: 0px;
	}

	.slick-prev, .slick-next{
		width: 40px;
		height: 40px;
		z-index: 1;
		
	}

	.slick-next {
    right: 2px;
}
.slick-prev {
    left: 2px;
 
}

element.style {
}
.slick-dots li button:before{
	color: #fff;
	opacity: 1;
}
.slick-dots li.slick-active button:before{
	color: #00baf2;
}
	.slick-prev:before, .slick-next:before {
  
    color: #00baf2;
	font-size: 25px;
    
}
`;
